import {Stack, Typography} from '@mui/material'
import React, {useEffect, useState} from 'react'
import {useTranslation} from 'react-i18next'
import TitlePage from '../customTable/TitlePage'
import Label from '../customTable/Label'
import ServiseFees from '../../Api/serviseFees'
import Loading from '../customTable/LoadingForm'
import NoNetWork from '../customTable/NoNetWork'
import FixedNumber from '../customTable/FixedNumber'

type FeeTier = {
  min: number
  max: number | null
  fee_amount: number
  fee_type: string
}

export default function InvoiceForm() {
  const {t} = useTranslation()
  const [tiers, setTiers] = useState<FeeTier[]>([])
  const [currency, setCurrency] = useState('')
  const [country, setCountry] = useState('')
  const bannerInfo = {
    title: t('servesFeesValue'),
    home: t('home'),
    linkHome: '/',
  }
  const [isLoading, setIsLoading] = useState(false)

  useEffect(() => {
    ServiseFees.getValue((res: any) => {
      const payload = res?.data ?? {}
      setTiers(Array.isArray(payload.tiers) ? payload.tiers : [])
      setCurrency(payload.currency ?? '')
      setCountry(payload.country ?? '')
    }, setIsLoading)
  }, [])

  return (
    <NoNetWork>
      <Stack>
        <TitlePage info={bannerInfo} />
        <Stack width={'100%'} position={'relative'}>
          {isLoading ? (
            <Loading />
          ) : (
            <Stack mt='21px' bgcolor={'#fff'} p='32px' borderRadius={'8px'} gap='24px'>
              <Stack gap='12px'>
                <Stack direction='row' alignItems='center' gap='8px'>
                  <Label fw='600' text='country' />
                  <Typography color='var(--bs-text-dark)'>:</Typography>
                  <Typography color='var(--bs-text-dark)'>{country || '—'}</Typography>
                </Stack>
                <Stack direction='row' alignItems='center' gap='8px'>
                  <Label fw='600' text='currency' />
                  <Typography color='var(--bs-text-dark)'>:</Typography>
                  <Typography color='var(--bs-text-dark)'>{currency || '—'}</Typography>
                </Stack>
              </Stack>

              <div className='table-responsive'>
                <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                  <thead>
                    <tr className='fw-bold text-muted'>
                      <th>
                        <Label text='minInvoiceAmount' />
                      </th>
                      <th>
                        <Label text='maxInvoiceAmount' />
                      </th>
                      <th>
                        <Label text='feeAmount' />
                      </th>
                      <th>
                        <Label text='feeType' />
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {tiers.length === 0 ? (
                      <tr>
                        <td colSpan={4}>
                          <Typography color='var(--bs-gray-600)'>{t('noData')}</Typography>
                        </td>
                      </tr>
                    ) : (
                      tiers.map((tier, index) => (
                        <tr key={`${tier.min}-${tier.max}-${index}`} className='fw-bold text-muted'>
                          <td>
                            <FixedNumber isNum num={tier.min} />
                          </td>
                          <td>
                            {tier.max === null || tier.max === undefined ? (
                              '∞'
                            ) : (
                              <FixedNumber isNum num={tier.max} />
                            )}
                          </td>
                          <td>
                            <Stack direction='row' alignItems='center' gap='5px'>
                              <FixedNumber isNum num={tier.fee_amount} />
                              {tier.fee_type === 'percentage' ? '%' : currency}
                            </Stack>
                          </td>
                          <td>
                            {tier.fee_type === 'percentage'
                              ? t('feeTypePercentage')
                              : t('feeTypeFixed')}
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </Stack>
          )}
        </Stack>
      </Stack>
    </NoNetWork>
  )
}
